// @flow

import $ from 'jquery';
import toastr from 'toastr';

function hideShadow() {

    if (!$('#toast-container').length) {
        $('body').removeClass('show-shadow');
    }

}

toastr.options = {
    "timeOut": 2000,
    "extendedTimeOut": 0,
    "closeButton": true,
    "closeHtml": '<span class="alert__close" title="Close" role="button"><span></span></span>',
    "onShown": function() {
        $('body').addClass('show-shadow');
    },
    "onCloseClick": function() {

        hideShadow();

    },
    "onHidden": function() {

        hideShadow();

    }
};

const notifier = {
    type: "success",
    defualtMessage: "Success",

    /**
     * Zarządza wyświetlaniem notyfikacji
     * @param response - obiekt odpowiedzi
     */
    showResponseNotification(response:Object) {
        if (response.status === 200) {
            if (response.data.msg) {
                toastr.success(response.data.msg);
            } else {
                // toastr.success('Success !');
                // Nie wyświetlaj toasta przy załadowaniu contentu ajaxowego
            }
        } else {
            toastr.error('Request Error !');
        }
    },

    showCustomNotification(type, msg) {
        let notifierType = type;
        let notifierMsg = msg;

        if (notifierType === undefined) throw new Error("No notifier type provided");
        if (notifierMsg === undefined) throw new Error("No notifier message provided");

        if (notifierType === 'success') {
            toastr.success(msg)
        } else {
            toastr.error(msg)
        }
    }
};

const loader = {
    loaderElement : $("#loader"),

    /**
     * Pokazuje loader
     */
    show() {
        const $this = this;
        if (this.loaderElement.length) {
            this.loaderElement.css('display', 'flex');
            this.loaderElement.addClass('is-active');
        }
    },

    /**
     * Ukrywa loader i opcjonalnie wyświetla msg
     * @param {object} response - obiekt odpowiedzi
     */
    hide(response) {
        const $this = this;
    if (this.loaderElement.length) {
        $this.loaderElement.removeClass('is-active');
    }

    if (response) {
        notifier.showResponseNotification(response)
    }
}};


function init() {
    $(document).ajaxStart(function () {
        loader.show();
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
        loader.hide();
    });
}

export {init, loader, notifier};



// WEBPACK FOOTER //
// ./src/_app/layout/loader.js